module.exports = "https://cdn2-fs.clearscore.com/flux/images/f207122d534e9e86b46a58f324f0a494.jpg";